import { isQaModeAllowedHost } from "./hostAllowlist";

/**
 * The one-shot gate for the Audio Lab's `?qa=audio` route - deliberately
 * its own tiny module (not folded into `QaMode.ts`'s `QaModeKind`/
 * `resolveQaMode`, which are read repeatedly per `GameScene` session to
 * gate an in-game overlay) since the Audio Lab is a wholly separate
 * `Phaser.Scene` reached straight from `MenuScene`, never through
 * `GameScene`/`LevelGame` at all - see `src/scenes/AudioLabScene.ts`'s doc
 * comment for why that isolation matters.
 *
 * One-shot per page load, same shape as `challengeRoute.ts`'s
 * `consumeInitialRoute`: once consumed (whether or not it actually matched
 * `?qa=audio`), it never fires again for this page load, so leaving the
 * Audio Lab back to the main menu can never bounce the player straight
 * back into it just because the URL still has `?qa=audio` in it.
 */
let consumed = false;

export function consumeAudioLabRoute(hostname: string | null | undefined, search: string): boolean {
  if (consumed) return false;
  consumed = true;
  if (!isQaModeAllowedHost(hostname)) return false;
  return new URLSearchParams(search).get("qa") === "audio";
}

/** Test-only: resets the one-shot gate between tests. */
export function __resetAudioLabRouteForTests(): void {
  consumed = false;
}
